import script from "./SegmentView.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentView.vue?vue&type=script&setup=true&lang=js"

import "./SegmentView.vue?vue&type=style&index=0&id=395f6c8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-395f6c8c"]])

export default __exports__